export default "__VITE_ASSET__407b7548__"